// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","instagram":"Footer_instagram__TCS4L","email":"Footer_email__DCDim","name":"Footer_name__xI97K"};